import { z } from 'zod';
import { adminPage } from './page';

/* POST /api/admin/broadcast (superadmin) */
export const BroadcastSchema = z
  .object({
    audience: z.enum(['all', 'spot']),
    spotId: z.string().optional(),
    title: z.string().min(1).max(80),
    body: z.string().min(1).max(280),
  })
  .refine((v) => v.audience !== 'spot' || !!v.spotId, {
    message: 'a spot broadcast needs spotId',
    path: ['spotId'],
  });
export type Broadcast = z.infer<typeof BroadcastSchema>;

export const BroadcastResultSchema = z.object({
  ok: z.literal(true),
  sent: z.number().int().nonnegative(),
});
export type BroadcastResult = z.infer<typeof BroadcastResultSchema>;

export const BroadcastEntrySchema = z.object({
  id: z.string(),
  actorHandle: z.string(),
  audience: z.string(),
  spotId: z.string().nullable(),
  title: z.string(),
  body: z.string(),
  sentCount: z.number().int().nonnegative(),
  createdAt: z.iso.datetime(),
});
export type BroadcastEntry = z.infer<typeof BroadcastEntrySchema>;

export const BroadcastHistoryResponseSchema = adminPage(BroadcastEntrySchema);
export type BroadcastHistoryResponse = z.infer<typeof BroadcastHistoryResponseSchema>;
